import React from 'react'
import classnames from 'classnames'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

import useStyles from './styles'

function SkeletonDescriptionText({ className, isInProgress, showLoadingAnimation }) {
  const classes = useStyles()

  return (
    <PreviewTextFieldSkeleton
      isInProgress={isInProgress}
      className={classnames(classes.skeletonDescription, className)}
      showLoadingAnimation={showLoadingAnimation}
    />
  )
}

export default SkeletonDescriptionText
